<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      value: this.item_value,
      categoryName: this.$route.params.categoryName,
      optiontoAlert: {
        Red: {
          displayName: "Critical",
          bgcolor: "#b60000",
          radioColor: "#b60000",
          color: "#fff",
        },
        Amber: {
          displayName: "Caution",
          bgcolor: "#ffeb3b",
          radioColor: "#a99518",

          color: "#000",
        },
        Green: {
          displayName: "Note",
          bgcolor: "#2a6528",
          radioColor: "#2a6528",

          color: "#fff",
        },
      },
    };
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
  },
};
</script>
<template>
  <div class="mb-3">
    <Label :item="item" />
    <div class="flex col-12 mt-2">
      <div
        v-for="option in item.options"
        v-bind:key="option"
        class="form-check col-4"
      >
        <input
          class="form-check-input"
          type="radio"
          v-model="value"
          v-bind:value="option"
          :disabled="
            categoryName == 'globalupdate'
              ? false
              : selectedItem.additionalProp1.global
              ? true
              : false
          "
          :style="
            option == 'Red'
              ? 'accent-color: #b60000 !important'
              : option == 'Amber'
              ? 'accent-color: #a99518 !important'
              : option == 'Green'
              ? 'accent-color: #2a6528 !important'
              : ''
          "
        />
        <p
          class="alert-tag font-size-14"
          :style="{
            backgroundColor: optiontoAlert[option].bgcolor,
            color: optiontoAlert[option].color,
          }"
        >
          {{ optiontoAlert[option].displayName }}
        </p>
      </div>
    </div>

    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
<style scoped>
.form-check-input {
  transform: scale(1.8);
  accent-color: #005eb8 !important;
  margin-top: 9px;
  cursor: pointer;
}
.alert-tag {
  color: #fff;
  padding: 5px 20px;
  font-size: 12px;
  margin-left: 10px;
  white-space: nowrap;
  max-width: 120px;
  text-align: center;
}
</style>
